import * as React from "react";
import { Form, Input, Checkbox } from "antd";
import { FormTypesGroupCategoryFormConstants } from "../../../common/Constants";

const FormTypesGroupCategoryForm = ({
  getFieldDecorator,
  translate,
  rowData
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: any;
}) => {
  return (
    <Form>
      <Form.Item label={translate("form_types_group_category_form.code")}>
        {getFieldDecorator(FormTypesGroupCategoryFormConstants.Fields.CODE, {
          initialValue: rowData && rowData.code,
          rules: [
            {
              required: rowData ? false : true,
              message: translate(
                "form_types_group_category_form.required_messages",
                {
                  field: translate("form_types_group_category_form.code")
                }
              )
            }
          ]
        })(<Input readOnly={rowData ? true : false} maxLength={FormTypesGroupCategoryFormConstants.VALIDATION_RULES.CODE_MAX_LENGTH}></Input>)}
      </Form.Item>
      <Form.Item label={translate("form_types_group_category_form.name")}>
        {getFieldDecorator(FormTypesGroupCategoryFormConstants.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: true,
              message: translate(
                "form_types_group_category_form.required_messages",
                {
                  field: translate("form_types_group_category_form.name")
                }
              )
            }
          ]
        })(<Input maxLength={FormTypesGroupCategoryFormConstants.VALIDATION_RULES.NAME_MAX_LENGTH}></Input>)}
      </Form.Item>
      <Form.Item label={translate("form_types_group_category_form.valid")}>
        {getFieldDecorator(FormTypesGroupCategoryFormConstants.Fields.VALID, {
          valuePropName: "checked",
          initialValue: rowData ? rowData.valid : true
        })(<Checkbox />)}
      </Form.Item>
    </Form>
  );
};

export default FormTypesGroupCategoryForm;
